import { useSearchParams } from "react-router-dom"

const usePagenation = (nowPage, maxPage) => {
    const [searchParams, setSearchParams] = useSearchParams()

    const prePageEvent = () => {
        if (nowPage > 1) {
            searchParams.set("page", parseInt(nowPage) - 1)
            setSearchParams(searchParams)
        }
    }

    const movePageEvent = (elem) => {
        searchParams.set("page", elem)
        setSearchParams(searchParams)
    }

    const nextPageEvent = () => {
        if (nowPage < maxPage) {
            searchParams.set("page", parseInt(nowPage) + 1)
            setSearchParams(searchParams)
        }
    }

    return [prePageEvent, movePageEvent, nextPageEvent]
}

export default usePagenation